"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Iterator {
    constructor(values) {
        this.i = 0;
        this.values = values;
    }
    current() {
        return this.values[this.i];
    }
    next() {
        const next = this.values[this.i];
        this.i++;
        if (this.i === this.values.length) {
            this.i = 0;
        }
        return next;
    }
    reset() {
        this.i = 0;
    }
}
exports.default = Iterator;
//# sourceMappingURL=Iterator.js.map